module.exports = __webpack_public_path__ + "img/新闻资讯_02.f9991701.png";